import React from 'react';
import {connect} from 'react-redux';
import {Tabs, Tab} from 'material-ui/Tabs';
import * as commonApi from '../../api/common-api';
import * as userApi from '../../api/user-api';
import Loading from 'react-loading';
import axios from 'axios';
import ProfileCourse from '../commons/profile/profile_course';
import ProfileConnections from '../commons/profile/profile_connections';
import ProfileRecomment from '../commons/profile/profile_recomment';
import ProfileEducation from '../commons/profile/profile_education';
import ProfileWork from '../commons/profile/profile_work';
import ProfileProject from '../commons/profile/profile_project';
import ProfileGroup from '../commons/profile/profile_group';
import ProfileSkill from '../commons/profile/profile_skill';
import ProfileBio from '../commons/profile/profile_bio';
import ProfileExtra from '../commons/profile/profile_extra';
import ImagePopup from '../commons/ImagePopup';
import POPUP from '../commons/popup';
import {IndexLink, Link, withRouter} from 'react-router';
import ReactGA from 'react-ga';
import {isMobile} from 'react-device-detect';
import ProfileAvailable from "../commons/profile/profile_available";

var isloaded = false;
const styles = {
    inkBarStyle: {
        backgroundColor: '#529ecc',
        height: '4px'
    },
    tabItemStyle: {
        backgroundColor: 'rgba(255, 255, 255, 1)',
        borderRadius: '10px',
        border: '1px solid #cad3df',
        boxShadow: '0 0 3px rgba(0, 0, 0, 0.3)'
        //color:'rgba(82, 158, 204, 1)'
    },
    headline: {
        fontSize: 24,
        paddingTop: 16,
        marginBottom: 12,
        fontWeight: 400,
    },
    slide: {
        padding: 10,
    },
};

const file_limit = 25 * 1024 * 1024;

class ProfilePage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        var slideIndex = 0;

        var profileId = this.props.params.profileId;

        // if (this.props.params.ptab == "connections") {
        //     slideIndex = 1;
        // }
        // if (this.props.params.ptab == "events") {
        //     slideIndex = 2;
        // }
        // this.state = {
        //     slideIndex: slideIndex,
        //     show: false,
        //     resume: {
        //         name_file: '',
        //        
        //     }
        // };
        this.handleChange = this.handleChange.bind(this);

        this.getProfile = this.getProfile.bind(this);
        this.state = {
            profileId: profileId, showDD: false, resume: {
                name_file: '',
                status: 0,
            }, score : 0, emerging: 0
        };
    }

    handleChange(value) {
        if (typeof value != "number") {
            return;
        }
        this.setState({
            slideIndex: value,
        });
        if (value == 0) {
            this.props.router.replace('/profile/' + this.state.profileId + '/about');
        }

        if (value == 1) {
            this.props.router.replace('/profile/' + this.state.profileId + '/connections');
        }
        if (value == 2) {
            this.props.router.replace('/profile/' + this.state.profileId + '/events');
        }


    };

    componentDidMount() {
        userApi.getMyProfile();
        this.getProfile();
    }

    getProfile() {
        axios.get(commonApi.getAPIURL() + '?api=getUserProfile&user_id=' + this.state.profileId)
            .then(response => {
                if (response.data.status == 1) {
                    if (response.data.data.is_verified_account == 0) {
                        // window.location = "/";  // hide apply to become freelancce
                        this.setState(Object.assign(this.state, {
                            user: response.data.data,
                            resume: response.data.data.resume,
                            score: response.data.data.score,
                            emerging: response.data.data.emerging
                        }));
                    } else {
                        this.setState(Object.assign(this.state, {
                            user: response.data.data,
                            resume: response.data.data.resume,
                            score: response.data.data.score,
                            emerging: response.data.data.emerging,
                        }));
                    }

                    //store.dispatch(getUserSuccess(response.data.data));
                }


                return response;
            });
    }

    componentWillReceiveProps(nextProps) {
        var load = false;
        if (this.state.profileId != nextProps.params.profileId) {
            load = true;
        }


        if (load) {
            this.setState({profileId: nextProps.params.profileId}, () => {
                this.getProfile();
            });
        } else {
            this.setState({profileId: nextProps.params.profileId});
        }
    }

    handleAttClick(event) {
        this.refs.file_input.value = '';
        this.refs.file_input.click();
    }

    handleFileUpload(event) {
        console.log("handleFileUpload");
        if (event.target.files.length > 0) {
            var fileUpload = event.target.files[0];
            if (fileUpload.size > file_limit) {
                commonApi.showAlert("Max file size is 25MB!");
                this.refs.file_input.value = '';
                return;
            }
            var Extension = fileUpload.name.substring(fileUpload.name.lastIndexOf('.') + 1).toLowerCase();
            var imageExt = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];
            if (imageExt.indexOf(Extension) != -1) {

                var data = new FormData();
                data.append('file', fileUpload);
                axios.post('/code/apis.php?api=updateAvatar', data)
                    .then(response => {
                        if (response.data.status == 1) {
                            this.getProfile();
                            //commonApi.showAlert("Your profile has been updated!");
                            //courseApi.getMyCourses();
                            //this.props.handleChange(2);
                            //store.dispatch(getUserSuccess(response.data.data));
                        } else {
                            commonApi.showAlert(response.data.message);
                        }
                        //console.log(response.data);

                        return response;
                    });

            } else {
                commonApi.showAlert("Please select image only");
                this.refs.file_input.value = '';
            }
        }

    }

    onInvite(event) {
        axios.get(commonApi.getAPIURL() + '?api=connectAccount&acc_id=' + this.state.user.id_account)
            .then(response => {
                if (response.data.status == 1) {
                    commonApi.showAlert("Your request has been sent!")
                    var msg = this.props.user[0].name_account + " " + this.props.user[0].last_name_account + " sent you a friend request";
                    var avatar = '/static/img/appimg/common-noavatar-sm.jpg';
                    if (this.props.user[0].image_avatar_account > 0) {
                        avatar = this.props.user[0].link_thumb_file;
                    }
                    var dataSend = {
                        from: this.props.user[0].id_account,
                        to: [this.state.user.id_account],
                        msg: msg,
                        icon: avatar
                    };
                    this.props.socket.emit('request', JSON.stringify(dataSend));
                    //console.log(response.data);
                    this.getProfile();
                }
                return response;
            });
    }

    onUnfriend(event) {
        axios.get(commonApi.getAPIURL() + '?api=removeConnect&acc_id=' + this.state.user.id_account)
            .then(response => {
                if (response.data.status == 1) {
                    //commonApi.showAlert("Your request has been sent!")
                    //console.log(response.data);
                    this.getProfile();
                }
                return response;
            });
    }

    onSendMessage(e) {
        axios.get(commonApi.getAPIURL() + '?api=getGroupByUser&id_account=' + this.state.user.id_account)
            .then(response => {
                if (response.data.status == 1) {
                    //commonApi.showAlert("Your request has been sent!")
                    //console.log(response.data);
                    //this.getConnections();
                    commonApi.openChatBox(response.data.data);
                }
                return response;
            });
    }

    onClose() {
        this.setState({show: false});
    }

    toggleDD(e) {
        e.stopPropagation();
        var showDD = !this.state.showDD;
        this.setState({showDD: showDD});
    }

    handleFileUpload2(event) {
        if (event.target.files.length > 0) {
            var fileUpload = event.target.files[0];
            if (fileUpload.size > file_limit) {
                commonApi.showAlert("Max file size is 25MB!");
                this.refs.file_input.value = '';
                return;
            }
            var Extension = fileUpload.name.substring(fileUpload.name.lastIndexOf('.') + 1).toLowerCase();
            var imageExt = ['pdf', 'xls', 'xlsx', 'doc', 'docx', 'txt'];
            if (imageExt.indexOf(Extension) != -1) {

                var data = new FormData();
                data.append('file', fileUpload);
                axios.post('/code/apis.php?api=updateResume', data)
                    .then(response => {
                        if (response.data.status == 1) {
                            isloaded = true;
                            this.setState({resume: response.data.data});
                        } else {
                            commonApi.showAlert(response.data.message);
                        }
                        return response;
                    });

            } else {
                commonApi.showAlert("Please select correct format");
                this.refs.file_input.value = '';
            }
        }

    }

    handleAttClick2(event) {
        this.refs.file_resume.value = '';
        this.refs.file_resume.click();
    }

    render() {
        if (this.state.user == undefined || this.props.user[0] == undefined) {
            return (
                <div className="app_page_wrapper">
                    <div style={{color: "#545454"}}>
                        <Loading delay={0} type='spinningBubbles' color='rgba(84, 84, 84, 1)' width={20} height={20}/>
                    </div>
                </div>
            );
        }
        var avatar = '/static/img/appimg/common-noavatar-sm.jpg';

        var favatar = "";
        if (this.state.user.image_avatar_account > 0) {
            favatar = this.state.user.link_file;
            avatar = this.state.user.link_thumb_file;
        }
        var invite = "";
        var resume = "";
        var emerging = "";
        if (this.state.user.id_account != this.props.user[0].id_account && this.props.isPublic != true) {
            if (this.state.user.connect_cur_user == -1) {
                invite = (<div className="common_header_btns">
                    <a onClick={this.onInvite.bind(this)} className="btn_v btn_confirm" style={{padding: '6px 15px', marginRight: '5px'}}>Connect</a>
                    <a onClick={this.onSendMessage.bind(this)} className="btn_v btn_cancel" style={{padding: '6px 15px'}}>Send a Message</a>
                </div>);
            } else if (this.state.user.connect_cur_user == 1) {
                invite = (<div className="common_header_btns message-block">
                    <a onClick={this.onSendMessage.bind(this)} className="btn_v btn_cancel" style={{padding: '6px 15px'}}>Send a Message</a>
                    <div className="profile_option">
                        <a onClick={this.toggleDD.bind(this)} className="trigger"><img src="/static/img/appimg/icon_down_black.png" alt=""/></a>
                        <div className={this.state.showDD ? "popupDrop" : "hide-el"}>
                            <ul>
                                <li className="post_icon_edit"><a onClick={this.onUnfriend.bind(this)}>Remove connection</a></li>
                            </ul>
                        </div>
                    </div>
                </div>);
            } else {
                invite = (<div className="common_header_btns message-block">
                    <a onClick={this.onSendMessage.bind(this)} className="btn_v btn_cancel" style={{padding: '6px 15px'}}>Send a Message</a>
                    <div className="profile_option">
                        <a onClick={this.toggleDD.bind(this)} className="trigger"><img src="/static/img/appimg/icon_down_black.png" alt=""/></a>
                        <div className={this.state.showDD ? "popupDrop" : "hide-el"}>
                            <ul>
                                <li className="post_icon_edit"><a onClick={this.onUnfriend.bind(this)}>Remove connection</a></li>
                            </ul>
                        </div>
                    </div>
                </div>);
            }

            if (this.state.emerging) {
                emerging = (<img src="/static/img/appimg/emerging.png" alt=""/>)
            }
        }
        else {
            invite = (
                <div className="common_header_btns message-block score-submit">
                    <div className={"project-score"}>
                        <div className={"percent"}>{this.state.score}</div>
                        <div className={"line-percent"}></div>
                        <div className={"processing"}>Project Success</div>
                    </div>
                </div>
            );

            if (this.state.emerging) {
                invite = (
                    <div className="common_header_btns message-block emerging-submit">
                        <div className={"project-emerging"}>
                            <img src="/static/img/appimg/emerging.png" alt=""/>
                        </div>
                    </div>
                );
            }
        }

        if (this.state.profileId == this.props.user[0].id_account) {
            if (this.state.resume.status == 0) {
                resume = (<div
                    className={"page_course_box profile_content_wrapper event_wrapper profile_upload ok"}>
                    <div className={"div-left"}>
                        <img className="img_circle resume_img" src="/static/img/appimg/resume-o.png"/>
                        <div className={"div-top"}>Why type everything again?</div>
                        <div className={"div-bottom"}>We can snag your education, work experiences, and skills from your
                            resume so you don't have to waste time typing it all in.
                        </div>
                    </div>
                    <div className={"div-right btn"} onClick={this.handleAttClick2.bind(this)}>Upload Resume</div>
                </div>)
            }
            if (this.state.resume.status == 1) {
                resume = (<div
                    className={"page_course_box profile_content_wrapper event_wrapper profile_upload ng"}>
                    <div className={"div-left"}>
                        <img className="img_circle resume_img" src="/static/img/appimg/resume-x.png"/>
                        <div className={"div-top"}>We couldn't find anything on this resume</div>
                        <div className={"div-bottom"}>This could be because of some unique formatting, or because this
                            resume was blank. Please try a different document.
                        </div>
                    </div>
                    <div className={"div-right btn"} onClick={this.handleAttClick2.bind(this)}>Upload Resume</div>
                </div>);
            }
            if (this.state.resume.status == 0 && this.state.resume.name_file != '') {
                resume = "";
            }
        }

        if(this.props.user[0] == undefined ){
            return (
                <div className="app_page_wrapper">
                    <div >
                        <div style={{color:"#545454"}}><Loading delay={0} type='spinningBubbles' color='rgba(84, 84, 84, 1)' width={20} height={20} /></div>
                    </div>
                </div>
            );
        }
        let bg_outside_url = '/static/img/appimg/default-banner.png'
        return (
            <div className={this.props.isPublic? "isPublic" : ""} id="div-profile">
                <div className={isMobile?"app-page-wrapper-mobile":"app_page_wrapper"}>
                    <div id="root-linkedin" className="profile-update" style={{paddingTop: "10px"}}>
                        <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" className="hidden" data-elementtiming="true" alt="" role="none"/>
                        <section id="ember3348" className="artdeco-card ember-view pv-top-card">
                            <div className="live-video-hero-image" style={{minHeight: "195.5px", maxHeight: "195.5px"}}>
                                <div tabIndex="0" aria-label="Profile background"
                                     className="profile-background-image">
                                    <div className="profile-background-image__image-container">
                                        <img
                                            className="profile-background-image__image full-width full-height no-marging-top"
                                            id="profile-background-image-target-image"
                                            alt="Background Image"
                                            src={bg_outside_url}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="ph5 pb5">
                                <div className="display-flex pv-top-card--reflow">
                                    <div className="pv-top-card--photo text-align-left">
                                        <div className="pv-top-card__photo-wrapper ml0">
                                            <div className="presence-entity presence-entity--size-9 pv-top-card__image">
                                                <a onClick={() => this.setState({show: true})}>
                                                    <img className="img_circle_p" src={avatar} alt=""/></a>
                                                {this.props.user[0].id_account == this.state.user.id_account ? (
                                                        <div className="upload_wrapper_profile">
                                                            <a onClick={this.handleAttClick.bind(this)}>
                                                                <img className="upload_img" src="/static/img/appimg/icon_upload_avatar.png"
                                                                     alt=""/>
                                                            </a>
                                                            <input type="file" className="hide-el" ref="file_input"
                                                                   onChange={this.handleFileUpload.bind(this)}/>
                                                        </div>)
                                                    : ""
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="pt3">
                                    <div className="org-top-card__primary-content org-top-card-primary-content--zero-height-logo org-top-card__primary-content--ia">
                                        <div className="block mt2">
                                            <div className="common_title02 pb5">
                                                <div>
                                                    <h1 className="org-top-card-summary__title t-24 t-black t-bold truncate" title="Microsoft On the Issues">
                                                        <span dir="ltr">{this.state.user.name_account + " " + this.state.user.last_name_account}</span>
                                                    </h1>
                                                    <p className="org-top-card-summary__tagline t-16 t-black">{this.state.user.name_university}{ this.state.user.name_major != '' ? " | " + this.state.user.name_major : ""}</p>
                                                    <p>{emerging}</p>
                                                </div>

                                            </div>
                                            {invite}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>

                    <div className="common_header01 common_header02 hide-el">
                        <div className="common_headlogo02"><a className="img_circle_wrapper" onClick={() => this.setState({show: true})}><img
                            className="img_circle_p" src={avatar} alt=""/></a>
                            {this.props.user[0].id_account == this.state.user.id_account ? (
                                    <div className="upload_wrapper">
                                        <a onClick={this.handleAttClick.bind(this)}>
                                            <img className="upload_img" src="/static/img/appimg/icon_upload_avatar.png"
                                                 alt=""/>
                                        </a>
                                        <input type="file" className="hide-el" ref="file_input"
                                               onChange={this.handleFileUpload.bind(this)}/>
                                    </div>)
                                : ""
                            }
                        </div>
                        <div className="common_title02">
                            <div>
                                <h2><b>{this.state.user.name_account + " " + this.state.user.last_name_account}</b></h2>
                                <p>{this.state.user.name_university + " | " + this.state.user.name_major}</p>
                                <p>{emerging}</p>
                            </div>

                        </div>
                        {invite}
                    </div>
                    <div id="profile-page" className="md-page md-page-profile">
                        <div className="page_course_main_wrapper">
                            <div className="content" style={{marginTop: 0}}>
                                <Tabs
                                    inkBarStyle={styles.inkBarStyle}
                                    onChange={this.handleChange}
                                    value={this.state.slideIndex}
                                    className="tab_container hide-el"
                                    tabItemContainerStyle={styles.tabItemStyle}
                                >
                                    <Tab label="About" value={0} className="tab_item"></Tab>
                                    <Tab label="Connections" value={1} className="tab_item"></Tab>
                                    <Tab label="Events" value={2} className="tab_item"></Tab>
                                </Tabs>
                                {resume}
                                <input type="file" className="hide-el" ref="file_resume"
                                       onChange={this.handleFileUpload2.bind(this)}/>

                                {isMobile ?
                                    <ProfileBio cuser={this.state.user} user={this.props.user[0]}
                                                profileId={this.state.profileId}
                                                my={this.state.profileId == this.props.user[0].id_account}/>
                                    :
                                    ""
                                }
                                <ProfileEducation user={this.props.user[0]} profileId={this.state.profileId}
                                                  my={this.props.user[0].supper_account == 1 || this.state.profileId == this.props.user[0].id_account}/>
                                <ProfileWork user={this.props.user[0]} profileId={this.state.profileId}
                                             my={this.props.user[0].supper_account == 1 || this.state.profileId == this.props.user[0].id_account}/>
                                <ProfileProject user={this.props.user[0]} profileId={this.state.profileId}
                                             my={this.props.user[0].supper_account == 1 || this.state.profileId == this.props.user[0].id_account}/>
                                <ProfileGroup user={this.props.user[0]} profileId={this.state.profileId}
                                              my={this.state.profileId == this.props.user[0].id_account}/>
                                <ProfileCourse user={this.props.user[0]} profileId={this.state.profileId}
                                               my={this.state.profileId == this.props.user[0].id_account}/>
                                {this.props.isPublic? "" :
                                <div>
                                <ProfileConnections user={this.props.user[0]} profileId={this.state.profileId}
                                                    my={this.state.profileId == this.props.user[0].id_account}/>
                                </div>
                                }
                                {isMobile ?
                                    "" :
                                    <ProfileRecomment user={this.props.user[0]} profileId={this.state.profileId}
                                                      my={this.state.profileId == this.props.user[0].id_account}/>
                                }
                                {/*<ProfileEvent user={this.props.user[0]} profileId={this.state.profileId}*/}
                                {/*              my={this.state.profileId == this.props.user[0].id_account}/>*/}
                            </div>
                        </div>
                    </div>
                    <div className="md-page-side md-page-profile">
                        {isMobile ?
                            ""
                            :
                            <ProfileBio cuser={this.state.user} user={this.props.user[0]}
                                        profileId={this.state.profileId}
                                        my={this.state.profileId == this.props.user[0].id_account}/>
                        }
                        <ProfileSkill user={this.props.user[0]} profileId={this.state.profileId}
                                      my={this.props.user[0].supper_account == 1 || this.state.profileId == this.props.user[0].id_account}/>
                        <ProfileAvailable cuser={this.state.user} user={this.props.user[0]}
                                    profileId={this.state.profileId}
                                    my={this.state.profileId == this.props.user[0].id_account}/>
                        <ProfileExtra user={this.props.user[0]} profileId={this.state.profileId}
                                      my={this.state.profileId == this.props.user[0].id_account}/>
                        {isMobile ?
                            <ProfileRecomment user={this.props.user[0]} profileId={this.state.profileId}
                                              my={this.state.profileId == this.props.user[0].id_account}/>
                            :
                            ""
                        }
                    </div>
                </div>

                {favatar != "" ? (
                    <POPUP style={commonApi.ImagePopupStyle()} show={this.state.show} onClose={this.onClose.bind(this)}
                           content={(<ImagePopup onClose={this.onClose.bind(this)} img={favatar}/>)}/>) : ""}
            </div>
        )
    }
}

ProfilePage.propTypes = {
    router: React.PropTypes.shape({
        push: React.PropTypes.func.isRequired
    }).isRequired
};
const mapStateToProps = function (store) {
    return {
        user: store.userState.user,
        socket: store.msgState.socket
    };
};

export default connect(mapStateToProps)(withRouter(ProfilePage));


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/pages/profile.js
 **/